import React from 'react';

import { DishType } from '../types';
import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage';

type Props = {
  dish: DishType;
  isFullPrice?: boolean;
  containerStyle?: React.CSSProperties;
};

export const Price: React.FC<Props> = ({dish, isFullPrice, containerStyle}) => {
  const MENU_CONFIG = getItemFromLocalStorage("menuConfiguration");
  
  return (
    <div
      className='row-center'
      style={{
        gap: 8,
        alignItems: 'center',
        ...containerStyle,
      }}
    >
      <span
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: 16,
          fontWeight: 700,
          color: 'var(--main-turquoise)',
        }}
      >
        &#8377;{isFullPrice ? dish.price : dish.halfPrice}
      </span>
      {MENU_CONFIG?.isInfoSupported && dish.kcal && (
        <>
          <div style={{
            width: 1,
            height: 12,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          }} />
          <span
            style={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 12,
              fontWeight: 400,
              color: 'var(--text-color)',
            }}
          >
            {dish.kcal} kcal
          </span>
        </>
      )}
    </div>
  );
};
